import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import ManagerMenu from "./ManagerMenu";
import SupportMenu from "./SupportMenu";

const SupportLayout = () => {
    return (
        <>
            <div className="wrapper">
                <Header />
                <SupportMenu />
                <Outlet />

                <div id="sidebar-overlay"></div>
            </div>
        </>
    );
};

export default SupportLayout;
